<template>
  <div>
    <div class=" is-fullwidth">
      <div class="buttons is-pulled-left" v-if="this.area == 'makeup'">
        <button class="button " @click="updateMakeupLocation(1)" :class="{'is-success' : makeup_location_id == 1}">Strabane</button>
        <button class="button " @click="updateMakeupLocation(3)" :class="{'is-success' : makeup_location_id == 3}" >Dublin</button>
        <button class="button " @click="updateMakeupLocation(4)" :class="{'is-success' : makeup_location_id == 4}">Derry</button>
        <button class="button "  @click="updateMakeupLocation(2)" :class="{'is-success' : makeup_location_id == 2}">Giurgiu</button>
        <button class="button "  @click="updateMakeupLocation('')" :class="{'is-success' : makeup_location_id == ''}">All</button>
        
      </div>
      <div class="is-pulled-right">
        <button class="button is-warning" @click="showCompleteError()" style="display:none">Export to CSV</button>
      </div>
    </div>
    
    <div class="notification is-info" v-if="loading == true " style="clear:both">Loading requests ...</div>

    <div class="notification is-success" v-if="loading == false && this.samples.length == 0 " style="clear:both">You have no open sample requests to view</div>

    <div v-if="loading==false && this.newSamples.length > 0" class="mb-6" style="clear:both">
      <h2 class="title">New Requests (Not Submitted Yet)</h2>
      <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
          <thead>
            <tr>
            <th>ID</th>
            <th>&nbsp;</th>
              <th>&nbsp;</th>
              
              <th>Qty</th>
              <th>Extras</th>
              <th style="display:none">Files</th>
              
              <th>Art.</th>
              <th>Digi.</th>
              <th style="display:none">Trans</th>
              <th>Gerber</th>
              <th>Sundries</th>
              <th>Makeup</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in newSamples">
            <tr  class="has-background-link-light" :key="'header' + row.id">
              <th ><router-link :to="'/samples/view/' + row.id" >{{ row.id}}</router-link></th>
                  <th colspan="8"> <span v-if="row.team_id > 0">{{ row.team_name}}</span>
                    <span v-if="row.team_id == -1">{{ row.club_name}}</span>
                    - {{  row.user_firstname }}  {{  row.user_surname }}
                  </th>
                  <th >&nbsp;</th>
                </tr>
              
              <tr v-for="(item, index) in row.items" :key="item.id">
                  <td>{{row.id}}.{{ index+1 }}</td>
                  <td>{{ item.garmentname }}</td>
                  <td>{{ item.sample_item_type_name }}</td>
                  <td>{{ item.quantity}}</td>
                  <td class="">
                    <div class="tags">
                      <span class="tag " v-if="item.embroidery==1" :class="{'is-success' : item.embroidery_completed==1}">Embroidery</span>
                      <span class="tag " v-if="item.trims==1" :class="{'is-success' : item.trims_completed==1}">Trims</span>
                      <span class="tag " v-if="item.dtf==1" :class="{'is-success' : item.dtf_completed==1}">DTF</span>
                      <span class="tag " v-if="item.silicon==1" :class="{'is-success' : item.silicon_completed==1}">Silcon</span>
                    </div>
                  </td>
                  <td style="display:none"><i class="fa fa-folder" aria-hidden="true"></i></td>
                  
                 <td><span class="button tag is-success" v-if="item.artwork_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.digital_print_completed==1">Done</span></td>
                  <td style="display:none"><span class="button tag is-success" v-if="item.trans_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.gerber_cutting_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.sundries_completed==1">Done</span></td>
                  <td><span class="button tag is-light" v-if="item.sample_item_type_id ==4">N/A</span>
                    <span class="button tag is-success" v-else-if="item.makeup_completed==1">Done</span></td>
              </tr>
            
            </template>
              
          </tbody>
        </table>
    </div>
    <!-- end of new samples-->
    
    <div v-if="loading==false && this.returnedSamples.length > 0" class="mb-6" style="clear:both">
      <h2 class="title">Returned Requests (Requires Action From You)</h2>
      <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
          <thead>
            <tr>
            <th>ID</th>
            <th>&nbsp;</th>
              <th>&nbsp;</th>
              
              <th>Qty</th>
              <th>Extras</th>
              <th style="display:none">Files</th>
              
              <th>Art.</th>
              <th>Digi Print</th>
              <th style="display:none">Trans</th>
              <th>Gerber</th>
              <th>Sundries</th>
              <th>Makeup</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in returnedSamples">
            <tr  :class="{'has-background-success-light' : row.processed == 1, 'has-background-link-light' : row.processed == 0}" :key="'header' + row.id">
              <th ><router-link :to="'/samples/view/' + row.id" >{{ row.id}}</router-link></th>
                  <th colspan="8"> <span v-if="row.team_id > 0">{{ row.team_name}}</span>
                    <span v-if="row.team_id == -1">{{ row.club_name}}</span>
                  - {{  row.user_firstname }}  {{  row.user_surname }}
                  </th>
                  <th >&nbsp;</th>
                </tr>
              
              <tr v-for="(item, index) in row.items" :key="item.id">
                  <td>{{row.id}}.{{ index+1 }}</td>
                  <td>{{ item.garmentname }}</td>
                  <td>{{ item.sample_item_type_name }}</td>
                  <td>{{ item.quantity}}</td>
                  <td class="">
                    <div class="tags">
                      <span class="tag " v-if="item.embroidery==1" :class="{'is-success' : item.embroidery_completed==1}">Embroidery</span>
                      <span class="tag " v-if="item.trims==1" :class="{'is-success' : item.trims_completed==1}">Trims</span>
                      <span class="tag " v-if="item.dtf==1" :class="{'is-success' : item.dtf_completed==1}">DTF</span>
                      <span class="tag " v-if="item.silicon==1" :class="{'is-success' : item.silicon_completed==1}">Silcon</span>
                    </div>
                  </td>
                  <td style="display:none"><i class="fa fa-folder" aria-hidden="true"></i></td>
                  
                  <td><span class="button tag is-success" v-if="item.artwork_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.digital_print_completed==1">Done</span></td>
                  <td style="display:none"><span class="button tag is-success" v-if="item.trans_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.gerber_cutting_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.sundries_completed==1">Done</span></td>
                  <td><span class="button tag is-light" v-if="item.sample_item_type_id ==4">N/A</span>
                    <span class="button tag is-success" v-else-if="item.makeup_completed==1">Done</span></td>
              </tr>
            
            </template>
              
          </tbody>
        </table>
    </div>
    <!-- end of returned samples-->

    <div v-if="loading==false && this.inProgressSamples.length > 0" style="clear:both">
      <h2 class="title">In Progress</h2>
      <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
          <thead>
            <tr>
            <th>ID</th>
            <th>&nbsp;</th>
              <th>&nbsp;</th>
              
              <th>Qty</th>
              <th>Extras</th>
              <th style="display:none">Files</th>
              
              <th>Art.</th>
              <th>Digi.</th>
              <th style="display:none">Trans</th>
              <th>Gerber</th>
              <th>Sundries</th>
              <th>Makeup</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in inProgressSamples">
            <tr  :class="{'has-background-success-light' : row.processed == 1, 'has-background-link-light' : row.processed == 0}" :key="'header' + row.id">
              <th ><router-link :to="'/samples/view/' + row.id" >{{ row.id}}</router-link></th>
                  <th colspan="9"> <span v-if="row.team_id > 0">{{ row.team_name}}</span>
                    <span v-if="row.team_id == -1">{{ row.club_name}}</span>
                  - {{  row.user_firstname }}  {{  row.user_surname }}
                  </th>
                  <th >&nbsp;</th>
                </tr>
              
              <tr v-for="(item, index) in row.items" :key="item.id">
                  <td>{{row.id}}.{{ index+1 }}</td>
                  <td>{{ item.garmentname }}</td>
                  <td>{{ item.sample_item_type_name }}</td>
                  <td>{{ item.quantity}}</td>
                  <td class="">
                    <div class="tags">
                      <span class="tag " v-if="item.embroidery==1" :class="{'is-success' : item.embroidery_completed==1}">Embroidery</span>
                      <span class="tag " v-if="item.trims==1" :class="{'is-success' : item.trims_completed==1}">Trims</span>
                      <span class="tag " v-if="item.dtf==1" :class="{'is-success' : item.dtf_completed==1}">DTF</span>
                      <span class="tag " v-if="item.silicon==1" :class="{'is-success' : item.silicon_completed==1}">Silcon</span>
                    </div>
                  </td>
                  <td style="display:none"><i class="fa fa-folder" aria-hidden="true"></i></td>
                  
                  <td><span class="button tag is-success" v-if="item.artwork_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.digital_print_completed==1">Done</span></td>
                  <td style="display:none"><span class="button tag is-success" v-if="item.trans_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.gerber_cutting_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.sundries_completed==1">Done</span></td>
                  <td><span class="button tag is-light" v-if="item.sample_item_type_id ==4">N/A</span>
                    <span class="button tag is-success" v-else-if="item.makeup_completed==1">Done</span></td>
              </tr>
            
            </template>
              
          </tbody>
        </table>
    </div>
    <!-- end of in progress samples -->
    
    <div v-if="loading==false && this.samples.length > 0" class="mt-6">
      <p class="has-background-link-light">Requests showing in blue are not yet processed from incoming requests.</p>
      <p class="has-background-success-light">Requests in green have been processed and are now in production.</p>
    </div>

    
  </div>
</template>

<script>



import SampleService from '@/services/SampleService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";



export default {
  components: {
        
      },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      makeup_location_id: '',
      order_by: 'deliverydate ASC',
      samples: [],
      selected_sample_id: 0
    }
  },
   methods: {
    updateMakeupLocation(new_location_id)
    {
        this.makeup_location_id = new_location_id
        this.getSamples()
    },
    showCompleteError() {
        alert("This button does not action anything. ")
    },
    viewRequest(id)
    {
        this.$router.push("/samples/view/" + id);
    },
      async getSamples() {
        this.loading=true
        if(this.area == "artwork")
        {
          
          SampleService.getSamplesForArtwork(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "digital_print")
        {
          
          SampleService.getSamplesForDigitalPrint(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
         else if(this.area == "gerber_cutting")
        {
          
          SampleService.getSamplesForGerberCutting(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "makeup")
        {
          
          SampleService.getSamplesForMakeup(this.accessToken, this.makeup_location_id)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "mysamples")
        {
          
          SampleService.getMySamples(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else {
          this.samples = [];
        }
      },
      
   
    
  },
  computed : {
      newSamples: function () {
        let newSamples =  this.samples.filter(function(u) {
            if(  u.submitted == 0) 
            {
              return 1
            }
          })
          return newSamples
     },
     returnedSamples: function () {
        let returnedSamples =  this.samples.filter(function(u) {
            if( u.submitted==1 && u.returned == 1) 
            {
              return 1
            }
          })
          return returnedSamples
     },
     inProgressSamples: function () {
        let inProgressSamples =  this.samples.filter(function(u) {
            if(u.submitted==1 &&  u.returned == 0) 
            {
              return 1
            }
          })
          return inProgressSamples
     },
     area: function() {
        if(this.$route.path == '/samples/list-samples/artwork')
        {
            return "artwork"
        }
        else if(this.$route.path == '/samples/list-samples/digital-print')
        {
            return "digital_print"
        }
        else if(this.$route.path == '/samples/list-samples/gerber-cutting')
        {
            return "gerber_cutting"
        }
        else if(this.$route.path == '/samples/list-samples/makeup')
        {
            return "makeup"
        }
        else if(this.$route.path == '/samples/list-samples/mysamples')
        {
            return "mysamples"
        }
        else {
          return ""
        }
    }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getSamples()
        });
  },
 
  mounted() {
    console.log(this.area.path)
      
  },
  watch: {
    
  }
}


</script>

